<template>
  <td>
    <div data-address="dataItem.address" :title="formatAddressForTitle(dataItem.address)">
      {{ formatAddress(dataItem.address) }}
    </div>

  </td>
</template>
<script>
export default {
  props: {
    dataItem: Object,
  },
  methods: {
      formatAddress (addr) {
        if (!addr) return "";
        if (addr.length > 50) {
            return addr.replaceAll('^', ' ').substring(0, 50) + '...';
        } else {
            return addr.replaceAll('^', ' ');
        }
      },
      formatAddressForTitle: function (addr) {
        if (!addr) return "";
        return addr.replaceAll('^', ' ');
      },
  },
};
</script>
<style scoped>
</style>